import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=576eadf4&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=js&"
export * from "./Administration.vue?vue&type=script&lang=js&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=576eadf4&prod&lang=scss&"
import style1 from "./Administration.vue?vue&type=style&index=1&id=576eadf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576eadf4",
  null
  
)

export default component.exports